import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Box,
  CircularProgress,
} from '@mui/material';
import { useNotification } from '../../contexts/NotificationContext';
import PageHeader from '../../components/common/PageHeader';
import CitaForm from '../../components/citas/CitaForm';

const CitaCreate = () => {
  const location = useLocation();
  const { showNotification } = useNotification();
  const [loading, setLoading] = useState(false);
  const [pacienteId, setPacienteId] = useState(null);
  
  // Extraer pacienteId de los parámetros de URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const paciente = params.get('paciente');
    
    if (paciente) {
      setPacienteId(parseInt(paciente, 10));
    }
  }, [location]);
  
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" my={5}>
        <CircularProgress />
      </Box>
    );
  }
  
  return (
    <Box sx={{ flexGrow: 1 }}>
      <PageHeader
        title="Nueva Cita"
        breadcrumbs={[
          { text: 'Dashboard', to: '/dashboard' },
          { text: 'Citas', to: '/citas' },
          { text: 'Nueva Cita' }
        ]}
      />
      
      <CitaForm pacienteId={pacienteId} />
    </Box>
  );
};

export default CitaCreate;